export let CalloutComponent: ng.IComponentOptions = {
  bindings: {
    type: "<",
    title: "<"
  },
  transclude: true,
  templateUrl: "angular-lte/components/callout.html"
};
